<template>
  <div v-if="item" class="mode19-box relative">
    <!-- {{ total }} -->
    <div class="mo19-content" :class="[IsMobile ? 'IsMobile' : '']">
      <div class="mo19-main-bg">
        <div class="mo19-main">
          <div class="mode-main-left">
            <div class="amount-row">
              <div class="txt1">{{ $t("Datalang.newly_total_free") }}:</div>
              <div class="txt2">{{ `${userFreeSymbol} ${divideAccuracy(Number(userFreeAmount), userAccuracy, true)}` }}</div>
            </div>
            <div class="progress-container">
              <div class="progress-bar">
                <div :class="!freeGold.hasFreeGoldWithdraw ? 'progress-inner2' : 'progress-inner'" :style="{ width: getProgressWidth}"></div>
                <img v-if="!freeGold.hasFreeGoldWithdraw" class="diamond" :src="require(`@/assets/user/p_vip.png`)" />
                <div class="progress-text notranslate">
                  <template v-if="!freeGold.hasFreeGoldWithdraw">
                    {{ $t("Datalang.newly_First_withdrawal") }}
                  </template>
                  <template v-else>
                    {{$t("Datalang.Bet_Amount")}}： {{ freeGold.coded }}/{{ freeGold.denominator }}
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="mode-main-right">
            <!-- <el-button class="btn-str" type="primary" size="medium" @click="goWithdraw">
              <el-tooltip
                ref='myTooltip'
                placement="top"
                manual
                :value="showTooltip"
                :popper-class="'registerTip zIndex2'"
                :append-to-body="true"
              >
                <div class="text" slot="content">
                  {{ $t("Datalang.newly_withdraw_here") }}
                  <img class="icon" :src="require(`@/lobby_common/assets/activity/gif.png`)" alt="" srcset="" />
                </div>
                <span>{{ btnTxt }}</span>
              </el-tooltip>
            </el-button> -->
            <div class="custom-tooltips" v-if="showTooltip  && !isWithdraw">
              <div class="text">
                {{ $t("Datalang.newly_withdraw_here") }}
              </div>
              <img class="icon" :src="require(`@/lobby_common/assets/activity/gifWallet.png`)" />
            </div>
            <el-button class="btn-str" :class="{ 'btn-str1': isWithdraw }" type="primary" size="medium" @click="goWithdraw">{{ btnTxt }}</el-button>
            <div class="tips" v-if="freeGold.status === 'FREE_GOLD_WITHDRAW_STATUS_CODE_NOT_ENOUGH'">
              <img class="icon" :src="require(`@/assets/activity/turntableVip/time_2.webp`)" alt="" srcset="" />
              <span>{{ timeTxt }}</span>
            </div>
            <div class="tips1" v-if="freeGold.status === 'FREE_GOLD_WITHDRAW_STATUS_FAIL'">{{ $t("Datalang.newly_failed_please") }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mode19 from "@/lobby_common/mixins_views/homeModule/mode19.js";
export default {
  mixins: [mode19],
  computed: {
    getProgressWidth() {
      // 0. 如果是首次提现，直接满格 (100%)
      if (!this.freeGold.hasFreeGoldWithdraw) return '100%';
      const { coded, denominator } = this.freeGold
      // 1. 如果数值为 0，则进度条为 0
      if (!coded || Number(coded) <= 0) return '0%'
      // 2. 计算真实比例
      const realPercentage = (Number(coded) / Number(denominator)) * 100
      // 3. 如果真实比例小于 0.05，则强制显示 0.05，否则按真实比例显示
      const finalPercentage = realPercentage < 0.05 ? 0.05 : realPercentage
      return `${finalPercentage}%`
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-tooltips{
  position: absolute;
  bottom: 36px;
  line-height: 28px;
  height: 28px;
  padding: 0 25px 0 10px;
  display: flex;
  border-radius: var(--radius-200);
  color: var(--font-color-200);
  background: var(--password-400);
  top: -5px;
  right: 10px;
  .text {
    white-space: nowrap;
  }
  .icon{
    position: absolute;
    height: 20px;
    right: -8px;
    top: 50%;
    transform: translateY(-50%);
  }
  &::after {
    content: '';
    position: absolute;
    left: 70%;
    transform: translateX(-50%);
    bottom: -4px;                    // 距离父元素底部
    width: 0;
    height: 0;
    border-width: 6px 6px 0 6px;     // 上、右、下、左 边宽
    border-style: solid;
    border-color: var(--password-400) transparent transparent transparent;
    pointer-events: none;
  }
}
.mo19-content {
  overflow: hidden;
  padding-top: 15px;
  // margin-top: 12px;
  font-size: 16px;
  color: var(--font-color-200);
  word-wrap: break-word;
  &.IsMobile {
    padding: 10px 10px 10px;
  }
  .content-desc{
    padding: 5px 15px;
    background: var(--background-800);
    border-radius: var(--radius-300);
    @media (max-width: 768px) {
      padding: 2px 10px;
    }
  }
}
.mo19-main-bg {
  border-radius: var(--radius-100);
  background: var(--background-2201);
}
.mo19-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  background-color: var(--background-700);
  // background-image: url('~@/assets/home/modeBg.png');
  background-size: auto 100%;
  background-repeat: no-repeat;
  border-radius: var(--radius-100);
  border-radius: var(--radius-301);
  padding: 10px 16px 14px 12px;
  .mode-main-left {
    display: flex;
    flex-direction: column;
    justify-content: center; // 使内部的 amount-row 和 progress-container 整体垂直居中
    height: 100%; // 继承父级高度
    .amount-row {
      display: flex;
      align-items: center;
      justify-content:space-between;
      gap: 6px;
      margin: 0;
      .txt1 {
        color: var(--font-color-100);
        font-size: 14px;
      }

      .txt2 {
        font-size: 18px;
        color: var(--font-color-1800);
        margin-right: 12px;
      }
    }

    .progress-container {
      margin-top: 6px;
      width: 215px; // 根据实际界面调整
      height: 15px;

      .progress-bar {
        width: 100%;
        height: 15px;
        background: var(--background-800); // 进度条底色
        border-radius: 8px;
        overflow: hidden;
        position: relative;
        border: 0px solid #3d424a;

        .progress-inner {
          height: 100%;
          background: var(--font-color-500); // 蓝色进度
          border-radius: 8px;
          transition: width 0.3s ease;
        }

        .progress-inner2 {
          height: 100%;
          background: var(--background-1401); // 黄色进度
          border-radius: 8px;
          transition: width 0.3s ease;
        }

        .progress-text {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 9px;
          color: #ffffff;
          display: flex;
          justify-content: flex-start;
          white-space: nowrap;
          z-index: 2;
        }

        .diamond {
          position: absolute;
          height: 10px;
          top: 50%;
          left: 26px;
          transform: translateY(-50%);
          z-index: 3;
        }
      }
    }
  }
  .mode-main-right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    font-size: 14px;
    @media (max-width: 768px) {
      font-size: 12px;
    }
    .btn-str {
      width: 100px;
      height: 34px;
      margin: 5px 0;
      padding: 0;
      @include buttonPrimary;
      @media (max-width: 768px) {
        width: 100px;
        height: 34px;
        padding: 5px 10px;
        font-size: 12px;
      }
    }
    .tips {
      display: flex;
      align-items: center;
      color: var(--font-color-200);
      > img {
        width: 14px;
        margin-right: 5px;
      }
    }
    .tips1 {
      color: var(--font-color-1500);
    }
  }
}
.btn-str1 {
  animation: scaleAnimation 1.5s ease-in-out infinite;
}
@keyframes scaleAnimation {
  0%, 100% { transform: scale(1); }
  50%      { transform: scale(1.1); }
}
</style>
